export const BUSINESS_RELATED_REPORT_IDS = [16, 40, 41, 64];
